
import React from 'react'
import { FiPhone } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RxEnvelopeClosed } from "react-icons/rx";
import { FaRegClock } from "react-icons/fa6";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";


const AboutContact = () => {
  return (
    <section className='bg-[#F0EDFD99] py-20 '>
        <h2 className='text-4xl md:text-[32px] font-semibold text-[#4B4B4B] text-center md:w-[90%]'>Get in touch with us today?</h2>
        <p className='font-medium text-base text-[#3D3939] text-center mb-16 mt-5 md:hidden'>
        With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
        </p>
        <p className='text-[#4E4949] font-normal text-base md:text-[15px] hidden md:block text-center mt-2 mb-9'>
        Dont let go of the opportunity to view our services

        </p>
        <section className='flex md:flex-col md:w-[90%] w-[75%] mx-auto'>
            <div>
            <div className='mb-5'>
                <div className='flex'>
<FiPhone color='#5E4FAC' className='w-[33px] h-[33px]'  />
<div className='ml-4'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Call Us</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    (+234) 815 6955508
    </p>
    <p className='text-[#656363] font-medium text-base'>
    (+234) 815 5768004
    </p>
</div>
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex'>
<HiOutlineLocationMarker color='#5E4FAC' className='w-[33px] h-[33px]'  />
<div className='ml-4'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Location</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    5, Agbon road, Iyano church, Ibadan.
    </p>
    <p className='text-[#656363] font-medium text-base  w-[70%]'>
    8, Agbon road, Iyano church, Ibadan, Oyo state, Nigeria
    </p>
</div>
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex'>
<RxEnvelopeClosed color='#5E4FAC' className='w-[33px] h-[33px]'  />
<div className='ml-4'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Email Address</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    quest-inspireeduconsult@yahoo.com
    </p>
    
</div>
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex'>
<FaRegClock color='#5E4FAC' className='w-[33px] h-[33px]'  />
<div className='ml-4'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Opening Hours</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    Mon-Fri  08:00 AM - 06:00 PM
    </p>
    
</div>
                </div>
            </div>
            <div className='flex  mt-14 md:mb-14 md:mt-5'>
                <FaTwitter color="#4C409C" className='w-[20px] h-[17px]' />
                <FaFacebookF color="#4C409C" className='w-[20px] h-[17px] ml-3' />
                <FaLinkedinIn color="#4C409C" className='w-[20px] h-[17px] ml-3' />
                <FaInstagram color="#4C409C" className='w-[20px] h-[17px] ml-3' />
            </div>
            </div>
            <div className='w-[60%] md:w-full'>
                
                <div className='mb-6'>
                    <label htmlFor="name" className='text-[#282828] text-base font-medium '>
                        Name
                    </label>
                    <input style={{border: '1px solid #A5A4A8'}} className='block rounded placeholder:text-[#828084] mt-2 w-full py-3 pl-3' type="text" placeholder='Enter Your Name' />
                </div>
                <div className='mb-6'>
                    <label htmlFor="email" className='text-[#282828] text-base font-medium'>
                        Email
                    </label>
                    <input className='block mt-2 w-full py-3 pl-3 rounded placeholder:text-[#828084]' style={{border: '1px solid #A5A4A8'}} type="text" placeholder='Enter Your Email' />
                </div>
                <div>
                    <label htmlFor="message" className='text-[#282828] text-base font-medium'>
                        Message
                    </label>
                    
                    <textarea className='w-full py-3 pl-3 mt-2 rounded placeholder:text-[#828084]'  style={{border: '1px solid #A5A4A8'}} rows="7" placeholder='Enter Your Message'></textarea>
                </div>
                <div className='w-full flex justify-center'>
                <button className='bg-[#5146AE] text-white w-fit rounded-lg px-10 mx-auto mt-10 py-[12px] '>Send Message</button>
                </div>
            </div>
        </section>
    </section>
  )
}

export default AboutContact